<style>
    .notifications {
		position: fixed;
		font-size: 14px;
		bottom: 0;
		left: 0;
		margin: 10px;
		max-height: initial;
		max-width: 300px;
		width: 300px;
        z-index: 1000000;
	}

	.notification {
		background-color: rgba(0, 0, 0, 0.822);
		color: white;
		padding: 10px;
		border-radius: 10px;
		margin-top: 10px;
		display: flex;
		animation: 5s ease-out 0s 1 grow;
		cursor: pointer;
	}

	.notification-img {
		width: 50px;
	}

	.notification-body {
		flex: 1;
		padding-right: 10px;
		padding-left: 10px;
	}

	.notification-close {
		width: 50px;
		text-align: right;
		font-weight: bold;
	}

	.notif-link {
		color: rgb(1, 204, 255);
		text-decoration: underline;
	}

	@keyframes grow {
		0% {
			opacity: 0;
		}
		20% {
			opacity: 1;
		}
		80% {
			opacity: 1;
		}
		100% {
			opacity: 1;
		}
	}

    @media (max-width:972px) {
		.notifications {
			top: 45px;
			bottom: initial;
		}
    }

</style>

<script>
import * as Common from './Common.js'

let notifications = []

const unsubsribe = Common.notifications.subscribe(value => {
    notifications = value
})
function removeNotification(n) {
    Common.notifications.update(curr => curr.filter(e => e != n))
}

</script>

{#if notifications.length > 0}
	<div class="notifications">
		{#each notifications as n}
			<div class="notification">
				{#if n.img}
					<div class="notification-icon">
						<img src={n.img} style="width: 40px;" alt="Notification Icon">
					</div>
				{/if}
				<div class="notification-body">
					{@html n.body}
				</div>
				<div class="notification-close" on:click={() => removeNotification(n)}>
					x
				</div>
			</div>
		{/each}
	</div>
{/if}